import React, { useEffect, useRef, useState } from "react";

import Clinic from "../components/Clinic";
import Doctor from "../components/Doctor";
import Service from "../components/Service";

import DateItem from "../components/Date";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "../constants/theme";
import moment from "moment/moment";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { getClinicByCode } from "../services/clinic/clinic.service";
import {
  getDrScheduleByDoctorIdAndDateRange,
  updateDrSchedule,
} from "../services/drSchedule/drSchedule.service";
import { useNavigate } from "react-router";

const AppointmentScreen = () => {
  const email = sessionStorage.getItem("email");
  const clinicCode = sessionStorage.getItem("clinicCode")
    ? JSON.parse(sessionStorage.getItem("clinicCode"))[0]?.clinic_code
    : "";
  const patientId = sessionStorage.getItem("patientId");
  const [activeDoctor, setActiveDoctor] = useState(0);

  const [clinicLoading, setClinicLoading] = useState(false);

  const [activeDate, setActiveDate] = useState(0);

  const dateSlotScrollRef = useRef();

  const [clinicData, setClinicData] = useState(undefined);
  const [clinicBranchesData, setClinicBranchesData] = useState([]);
  const [clinicDoctorData, setClinicDoctorData] = useState([]);
  const [branchDoctorData, setBranchDoctorData] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(undefined);
  const [selectedClinicBranch, setSelectedClinicBranch] = useState(undefined);
  const [selectedService, setSelectedService] = useState("");
  const [selectedDate, setSelectedDate] = useState({
    id: 0,
    day: "Today",
    date: moment().format("DD"),
    month: moment().format("MMM").toUpperCase(),
    year: moment().format("YYYY").toUpperCase(),
    fullDate: moment().format("YYYY-MM-DD"),
  });
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [drSchedule, setDrSchedule] = useState([]);
  const [morningSlots, setMorningSlots] = useState([]);
  const [daySlots, setDaySlots] = useState([]);
  const [eveningSlots, setEveningSlots] = useState([]);
  const [nightSlots, setNightSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(undefined);
  const navigate = useNavigate();

  const fetchClinicData = async () => {
    try {
      setClinicLoading(true);
      const res = await getClinicByCode(email, clinicCode, undefined);
      if (res.status === 200 && res.data.status === 200) {
        setClinicData(res.data.data);
        setClinicBranchesData(res.data.data.branches);
        setClinicDoctorData(res.data.data.doctors);
        setClinicLoading(false);
      } else {
        toast.error(res.data.message || res.message);
        setClinicData(undefined);
        setClinicBranchesData([]);
        setClinicDoctorData([]);
        setClinicLoading(false);
      }
    } catch (error) {
      toast.error(error.data.message || error.message);
      setClinicData(undefined);
      setClinicBranchesData([]);
      setClinicData(false);
      console.log("Error fetching clinic => ", error);
      return;
    }
  };

  useEffect(() => {
    fetchClinicData();
  }, []);

  useEffect(() => {
    if (selectedClinicBranch) {
      let tempData = clinicDoctorData.filter(
        (item) => item.branch === selectedClinicBranch.title
      );
      if (tempData && tempData.length > 0) setBranchDoctorData(tempData);
      else setBranchDoctorData(undefined);
    }
  }, [selectedClinicBranch]);

  const fetchDrSchedule = async () => {
    try {
      setScheduleLoading(true);
      const res = await getDrScheduleByDoctorIdAndDateRange(
        email,
        clinicCode,
        selectedDoctor?.doctor_email || selectedDoctor?.email,
        selectedDate?.fullDate,
        selectedDate?.fullDate
      );
      if (res.status === 200 && res.data.status === 200) {
        let data = [];
        if (res.data.data.length > 0) {
          data = res.data.data.filter(
            (item) => item.active && item.availability
          );
        }
        let morning =
          data && data.length > 0
            ? data.filter((item) => item.category === "Morning")
            : [];
        let day =
          data && data.length > 0
            ? data.filter((item) => item.category === "Day")
            : [];
        let evening =
          data && data.length > 0
            ? data.filter((item) => item.category === "Evening")
            : [];
        let night =
          data && data.length > 0
            ? data.filter((item) => item.category === "Night")
            : [];

        setMorningSlots(morning);
        setDaySlots(day);
        setEveningSlots(evening);
        setNightSlots(night);
        setDrSchedule(data);
        setScheduleLoading(false);
      } else {
        toast.error(res.data.message || res.message);
        setMorningSlots([]);
        setDaySlots([]);
        setEveningSlots([]);
        setNightSlots([]);
        setDrSchedule([]);
        setScheduleLoading(false);
      }
    } catch (error) {
      toast.error(error.data.message || error.message);
      setDrSchedule([]);

      setScheduleLoading(false);
      return;
    }
  };

  useEffect(() => {
    if (
      selectedClinicBranch &&
      selectedDoctor &&
      selectedService &&
      selectedDate
    ) {
      fetchDrSchedule();
    }
  }, [selectedClinicBranch, selectedDoctor, selectedService, selectedDate]);

  const generateDates = () => {
    const daysArray = [];

    for (let i = 0; i < 30; i++) {
      const currentDate = moment().add(i, "days");
      daysArray.push({
        id: i,
        day: i === 0 ? "Today" : currentDate.format("dddd"),
        date: currentDate.format("DD"),
        month: currentDate.format("MMM").toUpperCase(),
        year: currentDate.format("YYYY").toUpperCase(),
        fullDate: currentDate.format("YYYY-MM-DD"),
      });
    }

    return daysArray;
  };

  const dateData = generateDates();

  const handleLeftScroll = () => {
    const scrollElement = dateSlotScrollRef.current;

    const visibleWidth = scrollElement.clientWidth;

    scrollElement.scrollLeft -= visibleWidth - 100;
  };

  const handleRightScroll = () => {
    const scrollElement = dateSlotScrollRef.current;

    const visibleWidth = scrollElement.clientWidth;

    scrollElement.scrollLeft += visibleWidth - 100;
  };

  const handleAppointmentBooking = async () => {
    try {
      setClinicLoading(true);
      const res = await updateDrSchedule(
        email,
        selectedSlot.schedule_id,
        selectedSlot.company_code,
        selectedSlot.distributor_code,
        selectedSlot.clinic_code,
        patientId,
        selectedSlot.doctor_id,
        selectedSlot.date,
        selectedSlot.start_time,
        selectedSlot.end_time,
        selectedSlot.start_time_clock,
        selectedSlot.end_time_clock,
        "Scheduled",
        selectedSlot.active,
        selectedSlot.doctor_comment,
        "",
        false,
        selectedSlot.category,
        selectedService
      );
      if (res.status === 200 && res.data.status === 200) {
        toast.success(res.data.message);
        setClinicData(undefined);
        setClinicBranchesData([]);
        setClinicDoctorData([]);
        setBranchDoctorData(undefined);
        setMorningSlots([]);
        setDaySlots([]);
        setEveningSlots([]);
        setNightSlots([]);
        setDrSchedule([]);
        setScheduleLoading(false);

        setClinicLoading(false);
        navigate("/home");
      } else {
        toast.error(res.data.message || res.message);
        setClinicLoading(false);
      }
    } catch (error) {
      toast.error(error.data.message || error.message);
      setClinicLoading(false);
    }
  };

  return (
    <div
      className="position-relative"
      style={{
        // minHeight: "100vh",
        zIndex: "20",
        padding: "2px 15px 10px 15px",
      }}
    >
      <div
        className=""
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          padding: "13px 13px 13px 13px",
          borderRadius: "18px",
        }}
      >
        <div
          className="row w-100 mx-auto flex-column align-items-center justify-content-start"
          style={{
            marginTop: "10px",
            gap: "12px",
            // overflowY: 'scroll',
            // scrollBehavior: 'smooth'
          }}
        >
          {/* <h4
            className="text-center"
            style={{
              color: HEADER_COLOR,
            }}
          >
            Book Appointment
          </h4>

          <hr /> */}

          {clinicLoading && (
            <div style={{ height: "70vh" }}>
              <Loader />
            </div>
          )}

          {!clinicLoading && clinicData && clinicBranchesData.length > 0 && (
            <div style={{ minHeight: "80vh" }}>
              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                style={{
                  gap: "12px",
                }}
              >
                <div className="col-auto p-0">
                  <div
                    className="text-center"
                    style={{
                      fontSize: "14px",
                      color: "rgb(220, 143, 241)",
                    }}
                  >
                    Select Clinic
                  </div>
                </div>
                <div className="col-12 p-0 px-sm-5">
                  <div
                    className="row w-100 mx-auto align-items-center justify-content-center"
                    style={{
                      gap: "16px",
                    }}
                  >
                    {clinicBranchesData.map((clinic, index) => {
                      return (
                        <Clinic
                          key={clinic.title}
                          clinic={clinic}
                          selectedClinicBranch={selectedClinicBranch}
                          setSelectedClinicBranch={setSelectedClinicBranch}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>

              {selectedClinicBranch && (
                <>
                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-center mt-2"
                    style={{
                      gap: "5px",
                      paddingTop: "2px",
                    }}
                  >
                    {branchDoctorData && branchDoctorData.length > 0 && (
                      <>
                        {" "}
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "14px",
                              color: "rgb(220, 143, 241)",
                            }}
                          >
                            Select Doctor
                          </div>
                        </div>
                        <div className="col-12 p-0 px-sm-5">
                          <div
                            className="row w-100 mx-auto align-items-center justify-content-center"
                            style={{
                              gap: "20px",
                            }}
                          >
                            {branchDoctorData &&
                              branchDoctorData.length > 0 &&
                              branchDoctorData.map((doctor, index) => {
                                return (
                                  <Doctor
                                    key={doctor.email || doctor.doctor_email}
                                    doctor={doctor}
                                    selectedDoctor={selectedDoctor}
                                    setSelectedDoctor={setSelectedDoctor}
                                  />
                                );
                              })}
                          </div>
                        </div>
                      </>
                    )}
                    {(!branchDoctorData || branchDoctorData.length === 0) && (
                      <div className="col-auto mt-4">
                        <h5
                          className="text-center"
                          style={{
                            fontSize: "18px",
                            color: "black",
                          }}
                        >
                          No doctors available at selected clinic.
                        </h5>
                      </div>
                    )}
                  </div>

                  {selectedDoctor && (
                    <>
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center mt-2"
                        style={{
                          gap: "13px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "14px",
                              color: "rgb(220, 143, 241)",
                            }}
                          >
                            Select Services
                          </div>
                        </div>
                        <div className="col-12 p-0 px-sm-5">
                          <div
                            className="row w-100 mx-auto flex-column align-items-center"
                            style={{
                              gap: "15px",
                            }}
                          >
                            <div className="col-12 p-0">
                              <div
                                className="w-100 mx-auto"
                                style={{
                                  display: "grid",
                                  // gridTemplateColumns: "1fr 1fr",
                                  gridTemplateRows:
                                    "minmax(min-content, max-content)",
                                  gap: "15px",
                                }}
                              >
                                <Service />
                              </div>
                            </div>
                            <div className="col-12 p-0">
                              <div
                                className="w-100 mx-auto"
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gridTemplateRows:
                                    "minmax(min-content, max-content)",
                                  gap: "15px",
                                }}
                              >
                                <button
                                  className="btn w-100 service-btn"
                                  style={{
                                    padding: "7px",
                                    border:
                                      selectedService === "Consultation"
                                        ? `1px solid ${PRIMARY_COLOR}`
                                        : `1px solid rgb(250, 229, 255)`,
                                    backgroundColor:
                                      selectedService === "Consultation"
                                        ? "rgb(250, 229, 255)"
                                        : "",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    color: "rgb(153, 0, 204)",
                                    fontWeight: "400",
                                    transition: "font-weight .15s ease-in-out",
                                  }}
                                  onClick={(e) => {
                                    if (selectedService === "Consultation")
                                      setSelectedService("");
                                    else setSelectedService("Consultation");
                                    e.target.blur();
                                  }}
                                >
                                  Consultation
                                </button>

                                <button
                                  className="btn w-100 service-btn"
                                  style={{
                                    padding: "7px",
                                    border:
                                      selectedService === "Treatment Plan"
                                        ? `1px solid ${PRIMARY_COLOR}`
                                        : `1px solid rgb(250, 229, 255)`,
                                    backgroundColor:
                                      selectedService === "Treatment Plan"
                                        ? "rgb(250, 229, 255)"
                                        : "",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    color: "rgb(153, 0, 204)",
                                    fontWeight: "400",
                                    transition: "font-weight .15s ease-in-out",
                                  }}
                                  onClick={(e) => {
                                    if (selectedService === "Treatment Plan")
                                      setSelectedService("");
                                    else setSelectedService("Treatment Plan");
                                    e.target.blur();
                                  }}
                                >
                                  Treatment Plan
                                </button>

                                <button
                                  className="btn w-100 service-btn"
                                  style={{
                                    padding: "7px",
                                    border:
                                      selectedService === "Fabrication"
                                        ? `1px solid ${PRIMARY_COLOR}`
                                        : `1px solid rgb(250, 229, 255)`,
                                    backgroundColor:
                                      selectedService === "Fabrication"
                                        ? "rgb(250, 229, 255)"
                                        : "",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    color: "rgb(153, 0, 204)",
                                    fontWeight: "400",
                                    transition: "font-weight .15s ease-in-out",
                                  }}
                                  onClick={(e) => {
                                    if (selectedService === "Fabrication")
                                      setSelectedService("");
                                    else setSelectedService("Fabrication");
                                    e.target.blur();
                                  }}
                                >
                                  Fabrication
                                </button>

                                <button
                                  className="btn w-100 service-btn"
                                  style={{
                                    padding: "7px",
                                    border:
                                      selectedService === "Re-Fabrication"
                                        ? `1px solid ${PRIMARY_COLOR}`
                                        : `1px solid rgb(250, 229, 255)`,
                                    backgroundColor:
                                      selectedService === "Re-Fabrication"
                                        ? "rgb(250, 229, 255)"
                                        : "",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    color: "rgb(153, 0, 204)",
                                    fontWeight: "400",
                                    transition: "font-weight .15s ease-in-out",
                                  }}
                                  onClick={(e) => {
                                    if (selectedService === "Re-Fabrication")
                                      setSelectedService("");
                                    else setSelectedService("Re-Fabrication");
                                    e.target.blur();
                                  }}
                                >
                                  Re-Fabrication
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {selectedService && (
                        <>
                          <div
                            className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                            style={{
                              gap: "18px",
                            }}
                          >
                            <div className="col-auto p-0 pt-2 pb-2">
                              <div
                                className="text-center"
                                style={{
                                  fontSize: "14px",
                                  color: "rgb(220, 143, 241)",
                                }}
                              >
                                Select Your Slot
                              </div>
                            </div>
                            <div className="col-12 p-0 px-sm-4">
                              <div
                                className="row w-100 mx-auto align-items-center justify-content-center flex-nowrap"
                                style={
                                  {
                                    // gap: '10px'
                                  }
                                }
                              >
                                <div className="col-auto p-0">
                                  <div className="d-flex align-items-center justify-content-center">
                                    <SlArrowLeft
                                      style={{
                                        color: "rgb(203, 108, 230)",
                                        height: "16px",
                                        width: "16px",
                                      }}
                                      onClick={() => handleLeftScroll()}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col p-0 date-slot-scroll"
                                  ref={dateSlotScrollRef}
                                  style={{
                                    overflow: "scroll",
                                    scrollBehavior: "smooth",
                                    scrollbarWidth: "none",
                                  }}
                                >
                                  <div
                                    className="row w-100 mx-auto align-items-center justify-content-start flex-nowrap"
                                    style={{
                                      gap: "5px",
                                      // overflow: 'scroll',
                                    }}
                                  >
                                    {dateData.map((date, index) => {
                                      return (
                                        <DateItem
                                          key={date.id + date.day}
                                          date={date}
                                          selectedDate={selectedDate}
                                          setSelectedDate={setSelectedDate}
                                        />
                                      );
                                    })}
                                  </div>
                                </div>
                                <div className="col-auto p-0">
                                  <div className="d-flex align-items-center justify-content-center">
                                    <SlArrowRight
                                      style={{
                                        color: "rgb(203, 108, 230)",
                                        height: "16px",
                                        width: "16px",
                                      }}
                                      onClick={() => handleRightScroll()}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {selectedDate && scheduleLoading && <Loader />}

                          {selectedDate &&
                            !scheduleLoading &&
                            drSchedule.length === 0 && (
                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center mt-3"
                                style={{
                                  gap: "10px",
                                }}
                              >
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  No slots available for selected date!
                                </div>
                              </div>
                            )}

                          {selectedDate &&
                            !scheduleLoading &&
                            drSchedule &&
                            drSchedule.length > 0 && (
                              <>
                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center mt-3"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="text-center"
                                      style={{
                                        fontSize: "14px",
                                        color: "rgb(220, 143, 241)",
                                      }}
                                    >
                                      Morning
                                    </div>
                                  </div>

                                  {morningSlots && morningSlots.length > 0 && (
                                    <div
                                      className="w-100 mx-auto"
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gridTemplateRows:
                                          "minmax(min-content, max-content)",
                                        rowGap: "14px",
                                        columnGap: "10px",
                                        padding: "0 5px",
                                      }}
                                    >
                                      {morningSlots.map((item) => (
                                        <button
                                          className="btn w-100 service-btn d-flex justify-content-center align-items-center"
                                          style={{
                                            padding: "9px 8px",
                                            border:
                                              selectedSlot?._id === item?._id
                                                ? `1px solid ${PRIMARY_COLOR}`
                                                : `1px solid rgb(250, 229, 255)`,
                                            backgroundColor:
                                              selectedSlot?._id === item?._id
                                                ? "rgb(250, 229, 255)"
                                                : "",
                                            borderRadius: "20px",
                                            lineHeight: "1",
                                            fontSize: "12px",
                                            color: "rgb(153, 0, 204)",
                                            fontWeight: "400",
                                          }}
                                          onClick={(e) => {
                                            if (
                                              selectedSlot &&
                                              selectedSlot?._id === item?._id
                                            ) {
                                              setSelectedSlot(undefined);
                                            } else {
                                              setSelectedSlot(item);
                                            }
                                            e.target.blur();
                                          }}
                                        >
                                          {item?.start_time_clock} -{" "}
                                          {item?.end_time_clock}
                                        </button>
                                      ))}
                                    </div>
                                  )}

                                  {!morningSlots ||
                                    (morningSlots.length === 0 && (
                                      <p style={{ fontSize: "11px" }}>
                                        No slots available in the morning!
                                      </p>
                                    ))}
                                </div>

                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="text-center"
                                      style={{
                                        fontSize: "14px",
                                        color: "rgb(220, 143, 241)",
                                      }}
                                    >
                                      Day
                                    </div>
                                  </div>

                                  {daySlots && daySlots.length > 0 && (
                                    <div
                                      className="w-100 mx-auto"
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gridTemplateRows:
                                          "minmax(min-content, max-content)",
                                        rowGap: "14px",
                                        columnGap: "10px",
                                        padding: "0 5px",
                                      }}
                                    >
                                      {daySlots.map((item) => (
                                        <button
                                          className="btn w-100 service-btn d-flex justify-content-center align-items-center"
                                          style={{
                                            padding: "9px 8px",
                                            border:
                                              selectedSlot?._id === item?._id
                                                ? `1px solid ${PRIMARY_COLOR}`
                                                : `1px solid rgb(250, 229, 255)`,
                                            backgroundColor:
                                              selectedSlot?._id === item?._id
                                                ? "rgb(250, 229, 255)"
                                                : "",
                                            borderRadius: "20px",
                                            lineHeight: "1",
                                            fontSize: "12px",
                                            color: "rgb(153, 0, 204)",
                                            fontWeight: "400",
                                          }}
                                          onClick={(e) => {
                                            if (
                                              selectedSlot &&
                                              selectedSlot?._id === item?._id
                                            ) {
                                              setSelectedSlot(undefined);
                                            } else {
                                              setSelectedSlot(item);
                                            }
                                            e.target.blur();
                                          }}
                                        >
                                          {item?.start_time_clock} -{" "}
                                          {item?.end_time_clock}
                                        </button>
                                      ))}
                                    </div>
                                  )}

                                  {!daySlots ||
                                    (daySlots.length === 0 && (
                                      <p style={{ fontSize: "11px" }}>
                                        No slots available in the day!
                                      </p>
                                    ))}
                                </div>

                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="text-center"
                                      style={{
                                        fontSize: "14px",
                                        color: "rgb(220, 143, 241)",
                                      }}
                                    >
                                      Evening
                                    </div>
                                  </div>

                                  {eveningSlots && eveningSlots.length > 0 && (
                                    <div
                                      className="w-100 mx-auto"
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gridTemplateRows:
                                          "minmax(min-content, max-content)",
                                        rowGap: "14px",
                                        columnGap: "10px",
                                        padding: "0 5px",
                                      }}
                                    >
                                      {eveningSlots.map((item) => (
                                        <button
                                          className="btn w-100 service-btn d-flex justify-content-center align-items-center"
                                          style={{
                                            padding: "9px 8px",
                                            border:
                                              selectedSlot?._id === item?._id
                                                ? `1px solid ${PRIMARY_COLOR}`
                                                : `1px solid rgb(250, 229, 255)`,
                                            backgroundColor:
                                              selectedSlot?._id === item?._id
                                                ? "rgb(250, 229, 255)"
                                                : "",
                                            borderRadius: "20px",
                                            lineHeight: "1",
                                            fontSize: "12px",
                                            color: "rgb(153, 0, 204)",
                                            fontWeight: "400",
                                          }}
                                          onClick={(e) => {
                                            if (
                                              selectedSlot &&
                                              selectedSlot?._id === item?._id
                                            ) {
                                              setSelectedSlot(undefined);
                                            } else {
                                              setSelectedSlot(item);
                                            }
                                            e.target.blur();
                                          }}
                                        >
                                          {item?.start_time_clock} -{" "}
                                          {item?.end_time_clock}
                                        </button>
                                      ))}
                                    </div>
                                  )}

                                  {!eveningSlots ||
                                    (eveningSlots.length === 0 && (
                                      <p style={{ fontSize: "11px" }}>
                                        No slots available in the evening!
                                      </p>
                                    ))}
                                </div>

                                <div
                                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="text-center"
                                      style={{
                                        fontSize: "14px",
                                        color: "rgb(220, 143, 241)",
                                      }}
                                    >
                                      Night
                                    </div>
                                  </div>

                                  {nightSlots && nightSlots.length > 0 && (
                                    <div
                                      className="w-100 mx-auto"
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr",
                                        gridTemplateRows:
                                          "minmax(min-content, max-content)",
                                        rowGap: "14px",
                                        columnGap: "10px",
                                        padding: "0 5px",
                                      }}
                                    >
                                      {nightSlots.map((item) => (
                                        <button
                                          className="btn w-100 service-btn d-flex justify-content-center align-items-center"
                                          style={{
                                            padding: "9px 8px",
                                            border:
                                              selectedSlot?._id === item?._id
                                                ? `1px solid ${PRIMARY_COLOR}`
                                                : `1px solid rgb(250, 229, 255)`,
                                            backgroundColor:
                                              selectedSlot?._id === item?._id
                                                ? "rgb(250, 229, 255)"
                                                : "",
                                            borderRadius: "20px",
                                            lineHeight: "1",
                                            fontSize: "12px",
                                            color: "rgb(153, 0, 204)",
                                            fontWeight: "400",
                                          }}
                                          onClick={(e) => {
                                            if (
                                              selectedSlot &&
                                              selectedSlot?._id === item?._id
                                            ) {
                                              setSelectedSlot(undefined);
                                            } else {
                                              setSelectedSlot(item);
                                            }
                                            e.target.blur();
                                          }}
                                        >
                                          {item?.start_time_clock} -{" "}
                                          {item?.end_time_clock}
                                        </button>
                                      ))}
                                    </div>
                                  )}

                                  {!nightSlots ||
                                    (nightSlots.length === 0 && (
                                      <p style={{ fontSize: "11px" }}>
                                        No slots available in the night!
                                      </p>
                                    ))}
                                </div>

                                {selectedSlot && (
                                  <div className="p-0 mt-4 text-center">
                                    <button
                                      className="btn text-center"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "normal",
                                        backgroundColor: "rgb(203, 108, 230)",
                                        color: "rgb(250, 229, 255)",
                                        borderRadius: "20px",
                                        padding: "9px 26px",
                                        lineHeight: "1",
                                      }}
                                      onClick={() => {
                                        handleAppointmentBooking();
                                      }}
                                    >
                                      Book Appointment Now
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          )}

          {!clinicLoading &&
            (!clinicData || clinicBranchesData.length === 0) && (
              <>
                <div
                  className="row w-100 mx-auto flex-column align-items-center text-center"
                  style={{
                    gap: "12px",
                    height: "70vh",
                  }}
                >
                  <h6
                    style={{
                      color: SECONDARY_COLOR,
                    }}
                  >
                    No Clinics available. Contact Support!
                  </h6>
                </div>
              </>
            )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentScreen;
